export enum TargetGroup {
  STUDENT,
  TEACHER,
  PUBLIC
}
